class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('#LoadMoreButton');
    if (!this.button) return;
    this.button.addEventListener('click', this.loadMore.bind(this));
  }

  async loadMore() {
    const button = this.button;
    const nextUrl = button.dataset.nextUrl;
    if (!nextUrl) return;

    // Show loading state
    button.classList.add('loading');
    button.querySelector('.load-more-button__text').classList.add('hidden');
    button.querySelector('.load-more-button__spinner').classList.remove('hidden');
    button.disabled = true;

    try {
      const sectionId = button.dataset.sectionId;
      const separator = nextUrl.includes('?') ? '&' : '?';
      const url = `${nextUrl}${separator}section_id=${sectionId}`;

      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      // Get the new product items
      const newGrid = html.getElementById('product-grid');
      if (newGrid) {
        const newItems = newGrid.querySelectorAll('.grid__item');
        let currentGrid = document.getElementById('product-grid');

        // If the element with id="product-grid" wraps the <ul> instead of
        // being the <ul> itself (e.g. main-search), append into the inner grid.
        if (currentGrid && currentGrid.tagName !== 'UL') {
          currentGrid = currentGrid.querySelector('ul.product-grid') || currentGrid;
        }

        newItems.forEach((item) => {
          // Cancel scroll animation so items appear immediately
          item.classList.add('scroll-trigger--cancel');
          currentGrid.appendChild(item);
        });
      }

      // Check if there's another page
      const newLoadMoreButton = html.querySelector('#LoadMoreButton');
      if (newLoadMoreButton) {
        button.dataset.nextUrl = newLoadMoreButton.dataset.nextUrl;
        button.dataset.currentPage = newLoadMoreButton.dataset.currentPage;
        button.classList.remove('loading');
        button.querySelector('.load-more-button__text').classList.remove('hidden');
        button.querySelector('.load-more-button__spinner').classList.add('hidden');
        button.disabled = false;
      } else {
        // No more pages, remove the button
        button.remove();
      }

      // Re-initialize scroll animations if available
      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(document.getElementById('ProductGridContainer'));
      }
    } catch (error) {
      console.error('Load more failed:', error);
      button.classList.remove('loading');
      button.querySelector('.load-more-button__text').classList.remove('hidden');
      button.querySelector('.load-more-button__spinner').classList.add('hidden');
      button.disabled = false;
    }
  }
}

customElements.define('load-more-button', LoadMoreButton);
